import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTheme } from 'styled-components/macro';
import { useStore } from 'hooks';
import { MetersList } from './components';
import {
  LoaderWrapper,
  Title,
  TitleWrapper,
  ToggleWrapper,
} from './meters.styled';
import { LinesLoader } from '../../loaders';
import { Toggle } from '../../toggle';
import { CurrentAddress } from '../current-address';

interface IProps {
  inCallCard: boolean;
}

export const Meters = observer(({ inCallCard }: IProps) => {
  const { createRequest, meters } = useStore();
  const { requestData } = createRequest;
  const theme = useTheme();
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    if (
      !!requestData.area?._id &&
      meters.currentAreaId !== requestData.area?._id &&
      !meters.statuses.areaMetersAllReadings.pending
    ) {
      meters.getAreaMetersAllReadings({ area: requestData.area?._id });
    }
  }, [requestData.area?._id]);

  return meters.statuses.areaMetersAllReadings.pending ? (
    <LoaderWrapper inCallCard={inCallCard}>
      <LinesLoader size={'medium'} loaderType={'tenant'} />
    </LoaderWrapper>
  ) : (
    <>
      <div style={{ marginBottom: theme.spacings.base }}>
        <CurrentAddress />
      </div>
      <MetersList
        collapsed={false}
        meters={meters.openedMeters}
        isArchive={false}
      />
      <TitleWrapper>
        <Title>Архивные</Title>
        <ToggleWrapper>
          <Toggle open={open} onClick={() => setOpen(!open)} disabled={false} />
        </ToggleWrapper>
      </TitleWrapper>
      <MetersList
        collapsed={!open}
        meters={meters.archivedMeters}
        isArchive={true}
      />
    </>
  );
});
